import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { AboutUs } from '../HomePage/aboutUs';

const PageContainer = styled.div`
  ${tw`
    w-full
    max-w-full
    min-w-0
    min-h-screen
    flex
    flex-col
    bg-white
    items-center
    pt-10
    pb-20
    box-border
  `};
`;

const ContentWrapper = styled.div`
  ${tw`
    w-full
    max-w-screen-2xl
    max-w-full
    min-w-0
    box-border
  `};
`;

export default function AboutUsPage() {
  return (
    <PageContainer>
      <ContentWrapper>
        <AboutUs />
      </ContentWrapper>
    </PageContainer>
  );
}
